import * as dotProp from 'dot-prop-immutable';
import { Action } from 'typescript-fsa';

import { createReducer, User, UserApps } from '@topconagriculture/frontend-utils';

import { getApps, getUserById } from './user.actions';

export type UserState = {
  readonly applications: UserApps;
  readonly userProfile: User | null;
};

export const initialState: UserState = {
  applications: [],
  userProfile: null,
};

const userReducer = createReducer(initialState, {
  [getApps.done.type]: (state: UserState, action: Action<{ result: UserApps }>) => {
    return dotProp.set(state, 'applications', action.payload.result);
  },
  [getUserById.done.type]: (state: UserState, action: Action<{ result: User }>) => {
    return dotProp.set(state, 'userProfile', action.payload.result);
  },
});

export default userReducer;
